var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods_nav_auto_inner" },
    _vm._l(_vm.value.config.value, function (item) {
      return _c(
        "div",
        {
          key: item.type,
          class: ["box", "type" + item.type],
          style: { backgroundImage: "url(" + item.imageurl + ")" },
        },
        [
          item.type === "2"
            ? [
                _c("div", { staticClass: "header" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(item.title.slice(0, 6))),
                  ]),
                  _c("div", { staticClass: "arrow" }),
                ]),
                _c(
                  "div",
                  { staticClass: "goods-box" },
                  _vm._l(_vm.value.default_value, function (goods, index) {
                    return _c("div", { key: index, staticClass: "list" }, [
                      _c("div", {
                        staticClass: "goods-img",
                        style: {
                          backgroundImage: "url(" + goods.goods_thumb + ")",
                        },
                      }),
                      _c("div", { staticClass: "goods-name" }, [
                        _vm._v(_vm._s(goods.goods_name)),
                      ]),
                      _c("div", { staticClass: "goods-price" }, [
                        _vm._v(_vm._s(goods.shop_price) + " 点"),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }